import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import React, { useEffect, useState } from 'react';
import './checkbox.scss';
import classNames from 'classnames';
export var Checkbox = function Checkbox(_ref) {
  var name = _ref.name,
    children = _ref.children,
    className = _ref.className,
    propChecked = _ref.checked,
    onChange = _ref.onChange,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled;
  var _useState = useState(propChecked || false),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  useEffect(function () {
    setChecked(checked || false);
  }, [propChecked]);
  useEffect(function () {
    onChange === null || onChange === void 0 || onChange(checked);
  }, [checked, onChange]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames('checkbox', className)
  }, /*#__PURE__*/React.createElement("label", null, /*#__PURE__*/React.createElement("span", {
    className: "checkbox-control"
  }, /*#__PURE__*/React.createElement("input", {
    type: "checkbox",
    name: name,
    checked: checked,
    onChange: function onChange(e) {
      return setChecked(e.target.checked);
    },
    disabled: disabled
  }), /*#__PURE__*/React.createElement("span", {
    className: classNames('checkmark', {
      checked: checked
    })
  })), /*#__PURE__*/React.createElement("span", {
    className: "checkbox-label"
  }, children)));
};